'use es6';

import ActionTypes from '../actions/ActionTypes';
export const initialFavoritesTooltipState = {
  newFavouriteLessonId: null,
  newFavouriteTrackId: null,
  removedFavouriteLessonId: null,
  removedFavouriteTrackId: null
};
export function Favorites(state = initialFavoritesTooltipState, action) {
  switch (action.type) {
    case ActionTypes.BOOKMARKS_ADD_TRACK_RECEIVED:
      {
        return Object.assign({}, initialFavoritesTooltipState, {
          newFavouriteTrackId: action.meta.showTooltip ? action.payload.trackId : null
        });
      }
    case ActionTypes.BOOKMARKS_REMOVE_TRACK_RECEIVED:
      {
        return Object.assign({}, initialFavoritesTooltipState, {
          removedFavouriteTrackId: action.meta.showTooltip ? action.payload.trackId : null
        });
      }
    case ActionTypes.BOOKMARKS_ADD_LESSON_RECEIVED:
      {
        return Object.assign({}, initialFavoritesTooltipState, {
          newFavouriteLessonId: action.meta.showTooltip ? action.payload.lessonId : null
        });
      }
    case ActionTypes.BOOKMARKS_REMOVE_LESSON_RECEIVED:
      {
        return Object.assign({}, initialFavoritesTooltipState, {
          removedFavouriteLessonId: action.meta.showTooltip ? action.payload.lessonId : null
        });
      }
    case ActionTypes.BOOKMARKS_CLEAR_TOOLTIP:
      return initialFavoritesTooltipState;
    default:
      return state;
  }
}
export default Favorites;